module.exports = {
      id: "icon_offline_inspiration-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#icon_offline_inspiration-usage",
      toString: function () {
        return this.url;
      }
    }